import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { cn } from '../../../lib/utils';
import { Linguagem, realcar } from './realce';

export function BotaoCopiar({
  texto,
  rotulo = 'Copiar',
  className,
}: {
  texto: string;
  rotulo?: string;
  className?: string;
}) {
  const [copiado, setCopiado] = useState(false);

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(texto);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      // sem permissão de clipboard: o texto continua visível para copiar à mão
    }
  };

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={copiar}
      aria-label={rotulo}
      className={cn('h-7 gap-1 px-2 text-xs', className)}
    >
      {copiado ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      {copiado ? 'Copiado' : rotulo}
    </Button>
  );
}

const ROTULO_LINGUAGEM: Record<Linguagem, string | null> = {
  json: 'JSON',
  bash: 'cURL',
  js: 'JavaScript',
  python: 'Python',
  http: 'HTTP',
  texto: null,
};

export function BlocoCodigo({
  codigo,
  titulo,
  linguagem = 'texto',
}: {
  codigo: string;
  titulo?: string;
  linguagem?: Linguagem;
}) {
  const rotulo = ROTULO_LINGUAGEM[linguagem];
  return (
    <div className="overflow-hidden rounded-lg border border-[hsl(210,40%,20%)] bg-[hsl(210,50%,10%)] shadow-sm">
      <div className="flex items-center justify-between gap-2 border-b border-[hsl(210,40%,18%)] bg-[hsl(210,45%,14%)] px-3 py-1">
        <div className="flex min-w-0 items-center gap-2">
          <span className="truncate text-xs font-medium text-[hsl(210,30%,85%)]">{titulo}</span>
          {rotulo && rotulo !== titulo && (
            <span className="rounded bg-[hsl(43,56%,61%)]/15 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-[hsl(43,70%,68%)]">
              {rotulo}
            </span>
          )}
        </div>
        <BotaoCopiar
          texto={codigo}
          className="text-[hsl(210,30%,75%)] hover:bg-[hsl(210,40%,22%)] hover:text-white"
        />
      </div>
      <pre className="overflow-x-auto p-4 font-mono text-xs leading-relaxed text-[hsl(210,30%,92%)]">
        <code>{realcar(codigo, linguagem)}</code>
      </pre>
    </div>
  );
}
